"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userActivityMarkdown = exports.userActivityHtml = exports.userActivityFields = exports.hasRole = exports.hasFeature = exports.USER_FEATURE_AGENT_RUNTIME_SELECTION = exports.USER_FEATURE_RR_NEGATIVE_RESPONSE_NO_AUTO_EMAIL = exports.USER_FEATURE_NEVER = void 0;
exports.USER_FEATURE_NEVER = 0x00000000;
exports.USER_FEATURE_RR_NEGATIVE_RESPONSE_NO_AUTO_EMAIL = 0x00000001;
exports.USER_FEATURE_AGENT_RUNTIME_SELECTION = 0x00000002;
// tslint:disable-next-line: no-bitwise
const hasFeature = (user, feature) => ((user === null || user === void 0 ? void 0 : user.features) & feature) !== 0;
exports.hasFeature = hasFeature;
function hasRole(userPermissions, role) {
    var _a;
    return (_a = userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions[role]) !== null && _a !== void 0 ? _a : false;
}
exports.hasRole = hasRole;
function countsByClient(data) {
    const total = data.reduce((acc, c) => acc + c.count, 0);
    const text = data
        .sort((c1, c2) => c1.client.localeCompare(c2.client))
        .map((c) => `${c.client} (${c.count})`)
        .join(', ');
    return { total, text };
}
function userActivityFields(data) {
    var _a, _b, _c, _d;
    const fields = [];
    const pendingTasksList = [];
    if (data.emailsPending || data.emailsArchivedPending) {
        pendingTasksList.push(`${data.emailsPending + data.emailsArchivedPending} pending emails (${data.emailsPending} active, ${data.emailsArchivedPending} archived)`);
    }
    if (data.submitApprovedPending) {
        pendingTasksList.push(`${data.submitApprovedPending} candidates in Ready to Submit - waiting to be submitted`);
    }
    if (data.screenCompletePending) {
        pendingTasksList.push(`${data.screenCompletePending} candidates in Rocket Screen Complete - waiting to be submitted to AM or DQ'ed`);
    }
    if (data.screenScheduledElapsedPending) {
        pendingTasksList.push(`${data.screenScheduledElapsedPending} candidates in Rocket Screen Scheduled with interview time elapsed`);
    }
    if (data.rrPending) {
        pendingTasksList.push(`${data.rrPending} candidates waiting in Response Received`);
    }
    if (data.remindersPending) {
        pendingTasksList.push(`${data.remindersPending} pending Reminders`);
    }
    if (data.mentionsPending) {
        pendingTasksList.push(`${data.mentionsPending} pending Note/Submission mentions`);
    }
    if (pendingTasksList.length > 0) {
        fields.push('Pending Tasks', pendingTasksList);
    }
    else {
        fields.push('Emails, RR, Reminders, Mentions, Candidates in Rocket Screen all cleared');
    }
    const topOfFunnelList = [];
    if (data.searches.length > 0) {
        const searchesCount = data.searches.reduce((acc, s) => s.count + acc, 0);
        topOfFunnelList.push(`${searchesCount} new searches created`);
        topOfFunnelList.push(data.searches.map((s) => `${s.job} - ${s.count === 1 ? '1 search' : `${s.count} searches`} - ${s.newResults} new results`));
    }
    if (data.sourcing.length > 0) {
        const { total, text } = countsByClient(data.sourcing);
        topOfFunnelList.push(`${total} profiles sourced on LinkedIn - ${text}`);
    }
    if (data.outreachesSent.length > 0) {
        const { total, text } = countsByClient(data.outreachesSent);
        topOfFunnelList.push(`${total} outreach emails sent - ${text}`);
    }
    if (topOfFunnelList.length > 0) {
        fields.push('Top of Funnel', topOfFunnelList);
    }
    const upcomingCallsList = [];
    for (const { period, calls } of data.upcomingCalls) {
        const { total, text } = countsByClient(calls);
        upcomingCallsList.push(`${period}: ${total} calls - ${text}`);
    }
    fields.push('Upcoming calls', upcomingCallsList);
    if (data.rocketScreensCompleted.length > 0 || data.amSubmits.length > 0 || data.clientSubmits.length > 0) {
        const phoneCallsAndSubs = [];
        if (data.rocketScreensCompleted.length > 0) {
            const { text, total } = countsByClient(data.rocketScreensCompleted);
            phoneCallsAndSubs.push(`${total} phone screens - ${text}`);
        }
        if (data.amSubmits.length > 0) {
            const { text, total } = countsByClient(data.amSubmits);
            phoneCallsAndSubs.push(`${total} submissions to AM - ${text}`);
        }
        if (data.clientSubmits.length > 0) {
            const { text, total } = countsByClient(data.clientSubmits);
            phoneCallsAndSubs.push(`${total} submissions to Client - ${text}`);
        }
        fields.push(`Phone calls and Submits`, phoneCallsAndSubs);
    }
    if (data.messagesSent.length > 0) {
        const emailsList = [];
        const clientEmailsSent = (_b = (_a = data.messagesSent.find((s) => s.clientMessage)) === null || _a === void 0 ? void 0 : _a.count) !== null && _b !== void 0 ? _b : 0;
        const candidateEmailsSent = (_d = (_c = data.messagesSent.find((s) => !s.clientMessage)) === null || _c === void 0 ? void 0 : _c.count) !== null && _d !== void 0 ? _d : 0;
        if (clientEmailsSent > 0) {
            emailsList.push(`${clientEmailsSent} client emails responded`);
        }
        if (candidateEmailsSent > 0) {
            emailsList.push(`${candidateEmailsSent} candidate emails responded`);
        }
        fields.push(`Email Follow Ups`, emailsList);
    }
    if (data.clientAccepts.length > 0 || data.movedToFinalRound.length > 0 || data.movedToOffer.length > 0) {
        const clientStageList = [];
        if (data.clientAccepts.length > 0) {
            const { text, total } = countsByClient(data.clientAccepts);
            clientStageList.push(`${total} Client Accepts - ${text}`);
        }
        if (data.movedToFinalRound.length > 0) {
            const { text, total } = countsByClient(data.movedToFinalRound);
            clientStageList.push(`${total} moved to Client Final Round - ${text}`);
        }
        if (data.movedToOffer.length > 0) {
            const { text, total } = countsByClient(data.movedToOffer);
            clientStageList.push(`${total} moved to Offer - ${text}`);
        }
        fields.push('Client Stage Updates', clientStageList);
    }
    if (data.finalRounds.length > 0) {
        const { text, total } = countsByClient(data.finalRounds);
        fields.push(`${total} Active Final Rounds - ${text}`);
    }
    if (data.currentOffers.length > 0) {
        const total = data.currentOffers.reduce((acc, c) => acc + c.candidates.length, 0);
        const candidates = data.currentOffers.map((c) => `${c.job} (${c.candidates.join(', ')})`);
        fields.push(`${total} Offers Out`, candidates);
    }
    if (data.hires.length > 0) {
        const candidates = data.hires.map((c) => `${c.candidate} hired at ${c.job}`);
        fields.push(`${data.hires.length} Placement${data.hires.length > 1 ? 's' : ''}!`, candidates);
    }
    return fields;
}
exports.userActivityFields = userActivityFields;
function userActivityFieldToMarkDown(field, indentLevel = 0) {
    const bullet = indentLevel === 0 ? '•' : indentLevel === 1 ? '◦' : '-';
    let markDown = '';
    if (Array.isArray(field)) {
        markDown = markDown + field.map((f) => userActivityFieldToMarkDown(f, indentLevel + 1)).join('\n');
    }
    else {
        for (let i = 0; i < indentLevel; i++) {
            markDown += '\t';
        }
        markDown = `${markDown} ${bullet} ${field}`;
    }
    return markDown;
}
function userActivityFieldToHtmlList(field) {
    let html = '';
    if (Array.isArray(field)) {
        html = `<ul>${field.map(userActivityFieldToHtmlList).join('')}</ul>`;
    }
    else {
        html = `<li>${field}`;
    }
    return html;
}
function userActivityHtml(data) {
    const fields = userActivityFields(data);
    return `<ul>${fields.map(userActivityFieldToHtmlList).join('</li>')}</li></ul>`;
}
exports.userActivityHtml = userActivityHtml;
function userActivityMarkdown(data) {
    const fields = userActivityFields(data);
    return fields.map((f) => userActivityFieldToMarkDown(f, 0)).join('\n');
}
exports.userActivityMarkdown = userActivityMarkdown;
//# sourceMappingURL=user.js.map